// Whether an assessment question has been answered: a pick on a choice question,
// non-blank text on a written response, and nothing to answer on a question that
// offers neither.
//
// Read by the completeness validator that blocks a submit (academy_assessment_controller).
export function assessmentQuestionAnswered(question) {
  // A rating table is one question holding several answers, so "some input checked"
  // is not enough — EVERY item has to carry a rating, which is also what the server
  // requires. Without this a submit goes through after one row and the learner is
  // bounced back by a validation they had no way to see coming.
  const ratingRows = question.querySelectorAll(".academy-rating-table-row")
  if (ratingRows.length > 0) {
    // A row the author never named still renders — an empty row is part of the grid they
    // drew — but it cannot be something the learner is required to rate, because there is
    // nothing on it to read. The server draws the same line
    // (Academy::CoursesController#answer_missing? counts only the named rows), and the
    // two must agree or the button waits on an answer the server never wanted.
    const named = Array.from(ratingRows).filter((row) => !row.hasAttribute("data-rating-row-unnamed"))
    if (named.length === 0) return true

    return named.every((row) =>
      Array.from(row.querySelectorAll(".academy-quiz-option-input")).some((input) => input.checked)
    )
  }

  const choiceInputs = question.querySelectorAll(".academy-quiz-option-input")
  if (choiceInputs.length > 0) {
    return Array.from(choiceInputs).some((input) => input.checked)
  }

  const openInput = question.querySelector(".academy-quiz-open-input")
  return openInput ? openInput.value.trim() !== "" : true
}
